/**
 * 按元素类型选择把手组件；优先读取 elementRegistry。
 */
import type { ComponentType } from 'react';
import type { ElementType } from '@/components/canvas/document/publicTypes';
import { getHandlesComponentForType } from '@/components/canvas/elements/registry/elementRegistry';
import { ensureBuiltinElementsRegistered } from '@/components/canvas/elements/registry/registerBuiltinElements';
import { RectHandles } from './RectHandles';
import type { HandlesProps } from './types';

export { LineHandles } from './LineHandles';
export { RectHandles } from './RectHandles';
export type { HandlesProps } from './types';
export type { LineHandlesProps } from './LineHandles';
export type { RectHandlesProps } from './RectHandles';

export function getHandlesComponent(elementType: ElementType): ComponentType<HandlesProps> {
  ensureBuiltinElementsRegistered();
  return getHandlesComponentForType(elementType, RectHandles);
}
